export function search() {
  importBannersSets();
}

function importBannersSets() {
  const mainSearch = document.getElementById('MainSearch');
  if (!mainSearch) return;

  const footerBanners = document.querySelectorAll('#MainFooter_BannersetsFooter .bannerset-inner .banner');
  if (!footerBanners.length) return;

  if (document.getElementById('SearchAndBannersWrapper')) return;

  const searchWrapper = document.getElementById('SearchWrapper');
  if (!searchWrapper) return;

  const wrapper = document.createElement('div');
  wrapper.id = 'SearchAndBannersWrapper';
  wrapper.className = 'search-and-banners-wrapper wl-added';

  searchWrapper.before(wrapper);
  wrapper.appendChild(searchWrapper);

  const container = document.createElement('div');
  container.id = 'SearchBanners';
  container.className = 'search-banners wl-added';
  wrapper.appendChild(container);

  footerBanners.forEach((banner, index) => {
    const textEl = banner.querySelector('.banner-text');
    const text = (textEl?.textContent || banner.textContent || '').trim();
    const linkEl = banner.querySelector('a.banner-link');
    const href = linkEl?.getAttribute('href');

    const bannerElement = document.createElement('div');
    bannerElement.className = 'search-banner';
    bannerElement.dataset.index = index + 1;

    const pyramidIdMatch = banner.id?.match(/HEAD\d+_Banner_.+/);
    if (pyramidIdMatch) {
      bannerElement.dataset.pyramidId = pyramidIdMatch[0];
    }

    const icon = document.createElement('span');
    icon.className = 'search-banner-icon';
    icon.setAttribute('aria-hidden', 'true');

    const span = document.createElement('span');
    span.className = 'search-banner-text';
    span.textContent = text;

    if (href) {
      const link = document.createElement('a');
      link.className = 'search-banner-link';
      link.href = href;
   //   link.target = '_blank';
      link.rel = 'noopener';
      link.append(icon, span);
      bannerElement.appendChild(link);
    } else {
      bannerElement.append(icon, span);
    }

    container.appendChild(bannerElement);
  });
}
